$(document).ready(function() {
	// Page Top
	let pagetop = $('.pagetop');
	$(window).scroll(function() {
		if ($(this).scrollTop() > 200) {
			pagetop.fadeIn();
		} else {
			pagetop.fadeOut();
		}
	});
	// Scroll
	$('a[href^="#"]').click(function() {
		let speed = 200;
		let href = $(this).attr('href');
		let target = $(href === '#' || href === '' ? 'html' : href);
		let position = target.offset().top;
		$('html, body').animate({scrollTop: position}, speed, 'swing');
		return false;
	});
	// Font Size
	$('.font_size a').textresizer({
		target       : '#container',
		type         : 'fontSize',
		sizes        : ['100%', '110%', '120%'],
		selectedIndex: 0
	});
	// Global Menu
	$('.nav-item > a').matchHeight();
	$('#sp_menu a').matchHeight();
	$('.menu-container').accessibleMegaMenu();
	// lnav
	(function() {
		let $nav = $('.cad-lnav__list');
		let $navHTML = $nav.clone();
		$('.cad-lnav__sptgl-btn').on('click', function (e) {
			e.preventDefault();
			
			$.magnificPopup.open({
				fixedBgPos: true,
				fixedContentPos: true,
				items: {
					type: 'inline',
					src: '<div class="cad-modal-menu">' + $navHTML.html() +  '<div><button type="button" class="cad-modal-close">× 閉じる</button></div></div>'
				}
			});
			
			// if ($nav.hasClass('is-active')) {
			// 	$nav.slideUp();
			// 	$nav.removeClass('is-active');
			// 	$(this).find('.cad-lnav__sptgl-hum').removeClass('is-active');
			// 	$(this).find('.cad-lnav__sptgl-btntext').text('メニュー');
			// } else {
			// 	$nav.slideDown();
			// 	$nav.addClass('is-active');
			// 	$(this).find('.cad-lnav__sptgl-hum').addClass('is-active');
			// 	$(this).find('.cad-lnav__sptgl-btntext').text('メニューを閉じる');
			// }
		});
		$(window).on('resize', function() {
			if (768 <= $(this).width()) {
				$nav.removeAttr('style');
				if ($nav.hasClass('is-active')) {
					$nav.removeClass('is-active');
					$('.cad-lnav__sptgl-hum').removeClass('is-active');
					$('.cad-lnav__sptgl-btntext').text('メニュー');
				}
			}
		});
		$(document).on('click', '.cad-modal-close', function(e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
		$(document).on('click', '.cad-modal-menu .cad-lnav__item > a', function(e) {
			let href = $(this).attr('href');
			if (href.indexOf('#') === 0) {
				e.preventDefault();
				$(this).toggleClass('is-active');
				$(this).next().slideToggle();
			}
		});
		
		// ポジショニング
		$nav.find('.cad-lnav__item').each(function(i, elm) {
			let $elm = $(elm);
			let $subNav = $elm.find('.cad-lnav__subitem');
			if (i >= 4) {
				$subNav.css({
					'left':'auto',
					'right': 0
				});
			}
		});
		// イベント
		$nav.find('.cad-lnav__item')
			.on('mouseenter focus', function() {
				let self = this;
				$(this).find(' > a').next().show().find('a').attr('tabindex', 0);
			})
		.on('mouseleave blur', function() {
			$(this).find(' > a').next().hide();
			});
	}());
	// 数値カウントダウン
	(function() {
		let endDate = new Date('2019-08-28');
		let nowDate = new Date();
		let diffDate = endDate.getTime() - nowDate.getTime();
		// console.log(Math.round(diffDate / 1000 / 60 / 60 / 24));
		let lastDayCount = Math.round(diffDate / 1000 / 60 / 60 / 24);
		lastDayCount = lastDayCount < 1 ? 0 : lastDayCount;
		$('.cad-countdown__num').text(lastDayCount);
	}());
});
